<template>
  <home />
</template>
<script>
import { mapGetters } from "vuex";
import axios from "@/axios.js";
import helpers from "@/services/helpers";
import home from "../BackOffice";
export default {
  name: "MyReferrals",
  components: {
    home,
  },
  async created() {
    if (this.$route.params.ref) {
      localStorage.setItem("ref", this.$route.params.ref);
      this.msgConfirm();
    } else {
      this.$router.push({ name: "ecommerce" });
    }
  },
  data() {
    return {
      ref: "",
    };
  },
  methods: {
    msgConfirm() {
      this.boxTwo = "";
      this.$bvModal
        .msgBoxConfirm(
          `${this.$t("message_confirm_referrer")} ${localStorage.getItem(
            "ref"
          )}`,
          {
            title: this.$t("please_confirm_referrer"),
            size: "sm",
            buttonSize: "sm",
            okVariant: "danger",
            okTitle: this.$t("yes"),
            cancelTitle: this.$t("not"),
            footerClass: "p-2",
            hideHeaderClose: true,
            noCloseOnBackdrop: false,
          }
        )
        .then((value) => {
          if (value) {
            this.referred();
          } else {
            this.$router.push({ name: "dashboard" });
          }
        })
        .catch((err) => {
          helpers.handleError(err);
        });
    },
    async referred() {
      const res = await axios.post("/api/add-referred-user", {
        referring_code: localStorage.getItem("ref"),
      });
      if (res) {
        this.$toast.success(res.data.message, {
          position: "top-right",
        });
        localStorage.removeItem("ref");
        this.$router.push({ name: "dashboard" });
      }
    },
  },
  computed: {
    ...mapGetters({
      userData: "auth/check",
    }),
  },
};
</script>